import { api } from '@/api/core';
import { CASES_LIST_TAG, MATTER_ABOUT_TAG } from '@/api/constants';

/** Every field bar `matterId` is optional: the endpoint only edits what it is given. */
export interface MatterEditRequest {
  matterId: string;
  /** Omitted for Proclaim cases: their reference is owned by Proclaim and cannot be changed. */
  caseReference?: string;
  clientName?: string;
  defendant?: string;
  departmentId?: string;
  teamId?: string;
  fileHandlerId?: string | null;
}

export type MatterEditResponse = {
  matterId: string;
};

const matterEditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterEdit: builder.mutation<MatterEditResponse, MatterEditRequest>({
      query: (body) => ({
        url: '/matter/edit',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { matterId }) => [
        { type: CASES_LIST_TAG },
        { type: MATTER_ABOUT_TAG, id: matterId },
      ],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMatterEditMutation } = matterEditApi;
